/**
 * Element UI 表格列宽拖拽调整指令
 *
 * 用法: <el-table v-resize-column>...</el-table>
 *
 * 拖拽列右边界时，同时调整当前列和下一列的宽度，表格总宽不变。
 * Element UI 渲染多张独立表格（header + body），各有自己的 <colgroup>，
 * 需同时更新所有 colgroup 中对应列的 <col> 宽度。
 *
 * 列最小宽度: 50px
 */

let state = null

function thIndex(th) {
  const cells = th.parentElement.querySelectorAll('th')
  for (let i = 0; i < cells.length; i++) {
    if (cells[i] === th) return i
  }
  return -1
}

function nextTh(th) {
  const cells = th.parentElement.querySelectorAll('th')
  for (let i = 0; i < cells.length - 1; i++) {
    if (cells[i] === th) return cells[i + 1]
  }
  return null
}

function colsAt(tableEl, index) {
  const colgroups = tableEl.querySelectorAll('colgroup')
  const result = []
  colgroups.forEach(cg => {
    const children = cg.querySelectorAll('col')
    if (index < children.length) result.push(children[index])
  })
  return result
}

function onDown(e, th) {
  e.preventDefault()
  e.stopPropagation()

  const next = nextTh(th)
  if (!next) return // 最后一列不能拖

  const tableEl = th.closest('.el-table')
  const idx = thIndex(th)
  if (!tableEl || idx < 0) return

  state = {
    th,
    nextTh: next,
    cols: colsAt(tableEl, idx),
    nextCols: colsAt(tableEl, idx + 1),
    startX: e.clientX,
    startW: th.offsetWidth,
    nextStartW: next.offsetWidth
  }

  document.addEventListener('mousemove', onMove)
  document.addEventListener('mouseup', onUp)
  document.body.style.cursor = 'col-resize'
  document.body.style.userSelect = 'none'
}

function onMove(e) {
  if (!state) return
  const diff = e.clientX - state.startX
  const w = Math.max(50, state.startW + diff)
  const nw = Math.max(50, state.nextStartW - diff)

  state.th.style.width = w + 'px'
  state.th.style.minWidth = w + 'px'
  state.nextTh.style.width = nw + 'px'
  state.nextTh.style.minWidth = nw + 'px'

  state.cols.forEach(col => { col.style.width = w + 'px' })
  state.nextCols.forEach(col => { col.style.width = nw + 'px' })
}

function onUp() {
  document.removeEventListener('mousemove', onMove)
  document.removeEventListener('mouseup', onUp)
  document.body.style.cursor = ''
  document.body.style.userSelect = ''
  state = null
}

function ensureHandles(el) {
  const tableEl = el.classList.contains('el-table') ? el : el.querySelector('.el-table')
  if (!tableEl) return
  const headerWrapper = tableEl.querySelector('.el-table__header-wrapper')
  if (!headerWrapper) return
  const ths = headerWrapper.querySelectorAll('th')
  ths.forEach(th => {
    if (th.querySelector('.col-resize-bar')) return
    th.style.position = 'relative'
    const bar = document.createElement('div')
    bar.className = 'col-resize-bar'
    bar.style.cssText =
      'position:absolute;right:0;top:0;bottom:0;width:8px;cursor:col-resize;z-index:10'
    bar.addEventListener('mousedown', e => onDown(e, th))
    th.appendChild(bar)
  })
}

export default {
  bind(el) {
    setTimeout(() => ensureHandles(el), 300)
  },
  componentUpdated(el) {
    setTimeout(() => ensureHandles(el), 300)
  },
  unbind() {
    if (state) onUp()
  }
}
